import axios from "axios";

export function getContacts(limit = 100, cursor = null) {
    return axios.post(
        "/api/services/app/Mainstay/GetContactsAsync",
        null,
        { params: { limit, cursor } }
    );
}

export function getContactById(contactId) {
    return axios.post(
        "/api/services/app/Mainstay/GetContactByIdAsync",
        null,
        { params: { contactId } }
    );
}

export function createContact(contact) {
    return axios.post(
        "/api/services/app/Mainstay/CreateContactAsync",
        { contact }
    );
}

export function updateContact(contactId, changes) {
    return axios.post(
        "/api/services/app/Mainstay/UpdateContactAsync",
        { contactId, changes }
    );
}

export function testConnection() {
    return axios.post(
        "/api/services/app/Mainstay/TestConnectionAsync",
        null
    );
}

export function getMessages(input) {
    
    return axios.post(
        "/api/services/app/Mainstay/GetMessages",
         input
    );
}

export function syncChat() {

    return axios.post(
        "/api/services/app/Mainstay/SyncChats"
    );
}

export function getMessagesForContact(contactId, limit = 100, cursor = null, sinceUtc = null, untilUtc = null) {
    const params = {
        contactId,
        limit,
        cursor,
        sinceUtc: sinceUtc instanceof Date ? sinceUtc.toISOString() : sinceUtc,
        untilUtc: untilUtc instanceof Date ? untilUtc.toISOString() : untilUtc
    };
    return axios.get(
        "/api/services/app/Mainstay/GetMessagesForContact",
        { params }
    );
}
